import Pusher from 'pusher-js/with-encryption';
const authUrl = `${process.env.VUE_APP_FOCREX_API_URL}/trade/auth`;
const MyPusher = new Pusher(process.env.VUE_APP_PUSHER_KEY || 'test', {
    cluster: process.env.VUE_APP_PUSHER_CLUSTER,
    authEndpoint: authUrl,
    auth: {
        headers: {
            Authorization: ('Bearer ' + localStorage.getItem('token')),
        },
    },
});
Object.freeze(MyPusher);
export default MyPusher;
